import { render } from "./ArgonSnackbar.vue?vue&type=template&id=10adab76"
import script from "./ArgonSnackbar.vue?vue&type=script&lang=js"
export * from "./ArgonSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Nok/source/tccc/tccc-station-23-v2/tccc-frontend-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__